import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { EyedropperSample as EyedropperSampleIcon } from "@phosphor-icons/react/EyedropperSample";
import type { BaseMapTile } from "config/constants";
import { BASEMAPS_TILE } from "config/constants";
import map from "lodash/map";
import { FC } from "react";

export interface BaseMapProps {
	mapTile?: BaseMapTile;
	onBaseMapChange: (tile: BaseMapTile) => void;
}

export const BaseMap: FC<BaseMapProps> = ({ mapTile, onBaseMapChange }) => {
	return (
		<Stack
			direction="row"
			spacing={2}
			alignItems="center">
			<Typography variant="subtitle2">BaseMap</Typography>
			{map(BASEMAPS_TILE, (tile) => {
				const isSelected = mapTile?.id === tile.id;
				const avatarProps =
					tile.thumbnail !== ""
						? { src: tile.thumbnail }
						: tile.id === "custom"
							? { children: <EyedropperSampleIcon size={20} /> }
							: {};

				return (
					<IconButton
						key={tile.id}
						onClick={() => onBaseMapChange(tile)}>
						<Avatar
							variant="rounded"
							{...avatarProps}
							sx={{
								border: isSelected
									? "2px solid var(--mui-palette-primary-main)"
									: "none",
							}}
						/>
					</IconButton>
				);
			})}
		</Stack>
	);
};
